import { useId, useState } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button";
import { Checkbox, type CheckboxProps } from "@/components/Checkbox/Checkbox";
import { MoreDetailsDrawer } from "@/components/MoreDetailsDrawer/MoreDetailsDrawer";

type Props = CheckboxProps;

export const TermsAndConditions = (props: Props) => {
  const intl = useIntl();
  const checkboxId = useId();
  const [moreDetailsOpen, setMoreDetailsOpen] = useState(false);

  return (
    <>
      <div className="flex gap-2">
        <div className="shrink-0">
          <Checkbox id={checkboxId} disablePadding {...props} />
        </div>

        <div className="flex flex-col items-start gap-1 pt-1">
          <label
            className="text-sm font-semibold text-text-primary"
            htmlFor={checkboxId}
          >
            {intl.formatMessage({
              defaultMessage: "I accept the general Terms and Condition",
              description:
                "Checkbox label for accepting hotel general terms and conditions before booking",
            })}
          </label>
          <div className="text-sm text-text-tertiary">
            {intl.formatMessage({
              defaultMessage:
                "Before continuing you must accept our terms of Services",
              description:
                "Warning shown when user tries to proceed without accepting terms of service",
            })}
          </div>
          <Button
            size="small"
            variant="textFit"
            onClick={() => setMoreDetailsOpen(true)}
          >
            {intl.formatMessage({
              defaultMessage: "More details",
              description:
                "Button or link to expand and display additional details",
            })}
          </Button>
        </div>
      </div>

      <MoreDetailsDrawer
        open={moreDetailsOpen}
        onClose={() => setMoreDetailsOpen(false)}
      />
    </>
  );
};
